module.exports = __webpack_public_path__ + "static/media/reading-banner.731246a1.png";